import { TURNSTILE_SITE_KEY } from '@/app/config.js';
import { Turnstile } from '@marsidev/react-turnstile';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

export const verifyCaptcha = async (token) => {
  if (!token) {
    throw new Error('Completa el captcha');
  }
  return true;
};

// Los tokens de Turnstile son de UN SOLO USO: cada intento de login/submit lo
// consume en el servidor (siteverify), aunque la contraseña esté mala. El ref
// expone `reset()` para que el caller emita un token fresco tras cada intento
// fallido — sin esto, el reintento llega con token usado y el backend responde
// CaptchaInvalid (400).
// `onInteractive` avisa cuando Cloudflare ESCALA a desafío interactivo (el
// checkbox "Verifique que es un ser humano") — pasa cuando desconfía, p. ej.
// tras varios intentos fallidos seguidos. El caller puede ajustar su UI para
// dirigir al usuario al widget en vez de fingir que "está verificando".
export const TurnstileComponent = forwardRef(function TurnstileComponent(
  { onVerify, onInteractive },
  ref,
) {
  return (
    <Turnstile
      ref={ref}
      siteKey={TURNSTILE_SITE_KEY}
      onSuccess={onVerify}
      onExpire={() => onVerify('')}
      onError={() => onVerify('')}
      onBeforeInteractive={() => onInteractive?.()}
      options={{ language: 'es' }}
    />
  );
});

TurnstileComponent.propTypes = {
  onVerify: PropTypes.func.isRequired,
  onInteractive: PropTypes.func,
};
